import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-delete-step-completion',
  templateUrl: './delete-step-completion.component.html',
  styleUrls: ['./delete-step-completion.component.scss']
})
export class DeleteStepCompletionComponent implements OnInit {

  currentStepCompletionFormGroup: FormGroup = null;
  @Output() stepCompletionDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('deleteConfirmationModal', {static: false}) deleteConfirmationModal: ModalDirective;

  constructor(private workfowTemplateService: WorkflowTemplateService) { }

  ngOnInit(): void {
  }

  show(stepCompletionFormGroup: FormGroup) {
    this.currentStepCompletionFormGroup = stepCompletionFormGroup;
    this.deleteConfirmationModal.show();
  }

  deleteStepCompletion() {
    this.workfowTemplateService.deleteStepCompletion(this.currentStepCompletionFormGroup);
    this.stepCompletionDeleted.emit();
  }
}
